import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type CapModuleSpecsFragment } from '../../../../api/fragments/CapModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import CapModuleUpdateForm from './CapModuleUpdateForm';

export type CapModuleUpdateDrawerProps = {
    module: CapModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const CapModuleUpdateDrawer = ({ module, onClose, visible }: CapModuleUpdateDrawerProps) => {
    const { t } = useTranslation('capModuleDetails');

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('capModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateCapModule" htmlType="submit" type="primary">
                        {t('capModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('capModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <CapModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default CapModuleUpdateDrawer;

export const useUpdateCapModuleDrawer = (module: CapModuleUpdateDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <CapModuleUpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
